import React from 'react';
import { Star, MessageCircle } from 'lucide-react';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import { testimonials } from '../data/testimonials';
import { BUSINESS_INFO } from '../utils/constants';

const Reviews = () => {
  const averageRating = (testimonials.reduce((acc, t) => acc + t.rating, 0) / testimonials.length).toFixed(1);

  return (
    <div>
      <section className="section-blue" style={{padding: '4rem 0'}}>
        <div className="container text-center">
          <h1>Customer Reviews</h1>
          <p style={{fontSize: '1.25rem', maxWidth: '700px', margin: '0 auto 2rem'}}>
            See what our satisfied customers have to say about our service
          </p>
          
          {/* Rating Summary */}
          <div style={{
            display: 'inline-flex', 
            alignItems: 'center', 
            gap: '2rem', 
            backgroundColor: 'rgba(255, 255, 255, 0.1)', 
            backdropFilter: 'blur(10px)',
            borderRadius: 'var(--radius-xl)',
            padding: '2rem',
          }}>
            <div style={{textAlign: 'center'}}>
              <div style={{fontSize: '3rem', fontWeight: 700, color: 'var(--yellow-300)'}}>{averageRating}</div>
              <div className="flex gap-sm justify-center" style={{marginTop: '0.5rem'}}>
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={20} fill="var(--yellow-300)" color="var(--yellow-300)" />
                ))}
              </div>
            </div>
            <div style={{textAlign: 'left', borderLeft: '1px solid rgba(255, 255, 255, 0.2)', paddingLeft: '2rem'}}>
              <div style={{fontSize: '1.5rem', fontWeight: 700}}>{testimonials.length}+</div>
              <div style={{color: 'rgba(255, 255, 255, 0.8)'}}>Happy Customers</div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-cream">
        <div className="container">
          <div className="grid grid-3">
            {testimonials.map((review) => (
              <Card key={review.id} hover className="review-card">
                <div className="review-rating">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} size={20} fill="var(--yellow-400)" color="var(--yellow-400)" />
                  ))}
                </div>

                <p className="review-text">"{review.comment}"</p>

                <div className="review-service-badge">
                  {review.service}
                </div>

                <div className="review-author">
                  <div className="review-author-name">{review.name}</div>
                  <div className="review-author-location">{review.location}</div>
                  <div className="review-author-date">
                    {new Date(review.date).toLocaleDateString('en-GB', { 
                      year: 'numeric', 
                      month: 'long', 
                      day: 'numeric' 
                    })}
                  </div>
                </div>
              </Card>
            ))}
          </div>

          {/* CTA Section */}
          <div style={{marginTop: '4rem'}}>
            <Card style={{padding: '2rem', maxWidth: '700px', margin: '1px auto', textAlign: 'center'}}>
              <h2 style={{marginBottom: '1rem', marginLeft: '2rem'}}>Join Our Happy Customers</h2>
              <p style={{color: 'var(--gray-600)', marginBottom: '1.5rem', marginLeft: '2rem'}}>
                Experience the same professional service that earned us these 5-star reviews. 
                Book your mobile valeting service today!
              </p>
              <a href={BUSINESS_INFO.whatsappLink} target="_blank" rel="noopener noreferrer">
                <Button variant="whatsapp" size="lg" icon={MessageCircle}>
                  Book Your Service Now
                </Button>
              </a>
            </Card>
          </div>

          {/* Stats */}
          <div className="grid grid-4" style={{marginTop: '3rem'}}>
            <Card className="stat-card">
              <div className="stat-number">100%</div>
              <div className="stat-label">Customer Satisfaction</div>
            </Card>
            <Card className="stat-card">
              <div className="stat-number">100+</div>
              <div className="stat-label">Vehicles Serviced</div>
            </Card>
            <Card className="stat-card">
              <div className="stat-number">5★</div>
              <div className="stat-label">Average Rating</div>
            </Card>
            <Card className="stat-card">
              <div className="stat-number">2+</div>
              <div className="stat-label">Years Experience</div>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Reviews;